import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import {
  showClaimButton,
  showMarkAsCompleteButton,
  showMarkAsEditedButton,
  showMarkAsProofreadButton,
} from '@pages/User/RepositoryPage/components/JobsTable/JobStatusActionsButton';
import { useAuthContext } from '@providers/AuthProvider';
import { JobResponseDto } from 'app/API';
import { useJobStatusActions } from 'app/hooks/useJobStatusActions';

type TProps = {
  job: JobResponseDto;
  reload: () => Promise<void>;
};

export const JobStatusActionsButton = ({ job, reload }: TProps) => {
  const { workspace, organization } = useAuthContext();
  const { claim, markAsComplete, markAsEdited, markAsProofread, isPending } = useJobStatusActions({
    workspaceId: workspace?.id || '',
    onSuccess: reload,
  });

  if (showClaimButton(job, organization)) {
    return (
      <OutlinedButton disabled={isPending} onClick={() => claim(job.id)}>
        Claim Job
      </OutlinedButton>
    );
  }

  if (showMarkAsCompleteButton(job, organization)) {
    return (
      <OutlinedButton disabled={isPending} onClick={() => markAsComplete(job.id)}>
        Mark As Complete
      </OutlinedButton>
    );
  }

  if (showMarkAsEditedButton(job, organization)) {
    return (
      <OutlinedButton disabled={isPending} onClick={() => markAsEdited(job.id)}>
        Mark as Edited
      </OutlinedButton>
    );
  }

  if (showMarkAsProofreadButton(job, organization)) {
    return (
      <OutlinedButton disabled={isPending} onClick={() => markAsProofread(job.id)}>
        Mark as Proofread
      </OutlinedButton>
    );
  }

  return null;
};
